import { TAppStage } from './envConfig'

/**
 * available app run/deploy stages/environments
 * should be probably set as some ENV variable that is changed when dev/build script is run
 */

/**
 * config specific to speedlo-next apps,
 * common for all apps - shop, waiter,...
 *
 * each app should have its own values set as env variables in .env files
 */
export const getAppConfig = (appStage: TAppStage) => {
  const serverGuestToken = getServerGuestToken(appStage)
  const sentryDSN = getSentryDSN()

  if (!serverGuestToken) {
    throw new Error(
      `Missing SERVER_GUEST_TOKEN for ${appStage.toUpperCase()} app stage in env variables`,
    )
  }

  return {
    // DSN = data source name
    sentryDSN,
    serverGuestToken,
  } as const
}

// using one AUTH guest token for all of the Next server -> GQL server communication
// because we don’t have access to the user AUTH token, that is stored in the browser persistence, here on the server side
// TODO use cookie to store the auth token? https://medium.com/@ryanchenkie_40935/react-authentication-how-to-store-jwt-in-a-cookie-346519310e81
// -> until then, bear in mind that it’s not possible to query user-related information on the Next server (to be pre-rendered)
const getServerGuestToken = (appStage: TAppStage) => {
  // if custom token was provided via script param, use that one
  if (process.env.NEXT_PUBLIC_SERVER_GUEST_CUSTOM_TOKEN) {
    return process.env.NEXT_PUBLIC_SERVER_GUEST_CUSTOM_TOKEN
  }

  switch (appStage) {
    case `local`:
    case `dev`:
      return process.env.NEXT_PUBLIC_SERVER_GUEST_TOKEN_DEV

    case `stage`:
      return process.env.NEXT_PUBLIC_SERVER_GUEST_TOKEN_STAGE

    case `stageBeta`:
      return process.env.NEXT_PUBLIC_SERVER_GUEST_TOKEN_STAGE_BETA

    case `production`:
      return process.env.NEXT_PUBLIC_SERVER_GUEST_TOKEN_PRODUCTION

    default:
      return null
  }
}

// we don't need to send exceptions to Sentry in development (local)
// nextjs handles that via process.env.NODE_ENV which is 'development' when running next dev and 'production' running next start
// other app stages share one sentryDSN for now
// there may be a separate DSN for production in the future
const getSentryDSN = () => {
  const isProduction = process.env.NODE_ENV === 'production'

  if (isProduction) {
    return process.env.NEXT_PUBLIC_SENTRY_DSN
  }

  return ''
}
